import React, { useEffect } from 'react';

export function usePageVisibility() {
    const [isVisible, setIsVisible] = React.useState(true);

    const handleVisibilityChange = () => {
        setIsVisible(!document.hidden);
    };

    useEffect(() => {
        document.addEventListener('visibilitychange', handleVisibilityChange);
        return () => {
            document.removeEventListener('visibilitychange', handleVisibilityChange);
        };
    }, []);

    return isVisible;
}
